import { Box } from "@jewlr/storybook/core"
import React from "react"

import ImageBackgroundBanner from "components/landing/image-background-banner"

import TextBlock from "../text-block"
import WatchCollections from "../watch-collections"

import {
  banner,
  menWatchSize,
  womenWatchSize,
  menStrapStyles,
  womenStrapStyles,
  watchCollections,
} from "./data"
import ImageTextBlock from "./image-text-block"

const WatchSizing = () => (
  <Box mb="-48px">
    <ImageBackgroundBanner element={banner()} firstElement lazyload={false} />
    <Box contain pt={5} textAlign="center">
      <TextBlock
        description={
          <>
            Having just the right fit is essential to your watch&apos;s comfort
            and look.
            <br /> Create your watch with a choice of sizes perfect for you.
          </>
        }
        descriptionStyle={{
          px: { _: 6, tablet: 2 },
          width: { desktop: "54%", tablet: "75%" },
        }}
        title="The Perfect Watch Fit"
      />

      <ImageTextBlock
        data={menWatchSize()}
        description="Choose your size: We offer a variety of men’s case sizes – select the diameter that suits your style."
        titlebar="Watch Size Guide For Men"
      />
      <ImageTextBlock
        data={menStrapStyles()}
        description="Choose your strap: Designed for the perfect fit, our adjustable straps are available in a choice of styles."
        strapStyle
        title="Strap Styles & Fit"
      />
      <ImageTextBlock
        data={womenWatchSize()}
        description="Choose your size: We offer a variety of women’s case sizes – select the diameter that reflects your look."
        titlebar="Watch Size Guide For Women"
      />
      <ImageTextBlock
        data={womenStrapStyles()}
        description="Choose your strap: Designed for the perfect fit, our adjustable straps are available in a choice of styles."
        strapStyle
        title="Strap Styles & Fit"
      />
    </Box>
    <WatchCollections data={watchCollections()} />
  </Box>
)

export default WatchSizing
